<template>
  <div class="page">
    <div class="loading-box" v-if="percentNum<100">
      <img class="load-img" src="../../assets/dh-map/logo.png" alt="">
      <!--<img class="load-img" src="../../assets/dh-map/loading-gif.gif" alt="">-->
      <div class="bar">
        <div class="bar-curr"></div>
      </div>
      <div class="bar-txt">页面正在火速赶来...{{percentNum}}%</div>
    </div>
    <div id="second1" class="second" v-show="navCurr==1">
      <img id="demoImg1" class="top-img t1" src="../../assets/dh-map/floor1-img.png" alt="">
      <img class="room floor1-lz1" src="../../assets/dh-map/floor1-lz1.png" alt="">
      <!--临展2.3为古代体育文化特展shopid=1591-->
      <img class="room floor1-lz2 link" src="../../assets/dh-map/floor1-lz2.png" alt=""  @click="goViewDetail(1591)">
      <img class="room floor1-lz3 link" src="../../assets/dh-map/floor1-lz3.png" alt=""  @click="goViewDetail(1591)">
      <!--汉代陶石1馆shopid=1149-->
      <img class="room floor1-ht1 link" src="../../assets/dh-map/floor1-ht1.png" alt="" @click="goViewDetail(1149)" >
      <!--汉代陶石2馆shopid=1319-->
      <img class="room floor1-ht2 link" src="../../assets/dh-map/floor1-ht2.png" alt="" @click="goViewDetail(1319)" >
    </div>
    <div id="second2" class="second" v-show="navCurr==2">
      <img id="demoImg2" class="top-img t1" src="../../assets/dh-map/floor2-img.png" alt="">
      <img class="room floor2-cbbgq" src="../../assets/dh-map/floor2-cbbgq.png" alt="">
      <img class="room floor2-cbxy" src="../../assets/dh-map/floor2-cbxy.png" alt="">
      <!--张大千艺术馆shopid=1313-->
      <img class="room floor2-zdqysg link" src="../../assets/dh-map/floor2-zdqysg.png" alt="" @click="goViewDetail(1313)" >
      <!--远古四川shopid=1412-->
      <img class="room floor2-ygsc link" src="../../assets/dh-map/floor2-ygsc.png" alt=""  @click="goViewDetail(1412)" >
      <img class="room floor2-xsbgt" src="../../assets/dh-map/floor2-xsbgt.png" alt="">
      <img class="room floor2-shg" src="../../assets/dh-map/floor2-shg.png" alt="">
      <img class="room floor2-gdsc" src="../../assets/dh-map/floor2-gdsc.png" alt="">
      <img class="room floor2-bgq" src="../../assets/dh-map/floor2-bgq.png" alt="">

    </div>
    <div id="second3" class="second" v-show="navCurr==3">
      <img id="demoImg3" class="top-img t1" src="../../assets/dh-map/floor3-img.png" alt="">
      <img class="room floor3-xxjjy" src="../../assets/dh-map/floor3-xxjjy.png" alt="">
      <img class="room floor3-zyzzj" src="../../assets/dh-map/floor3-zyzzj.png" alt="">
      <!--四川民族文物馆shopid=1315-->
      <img class="room floor3-scmzwwg link" src="../../assets/dh-map/floor3-scmzwwg.png" alt="" @click="goViewDetail(1315)" >
      <img class="room floor3-lz5" src="../../assets/dh-map/floor3-lz5.png" alt="">
      <!--工艺美术馆shopid=1314-->
      <img class="room floor3-gymsg link" src="../../assets/dh-map/floor3-gymsg.png" alt=""  @click="goViewDetail(1314)" >
      <img class="room floor3-zcfjwwg" src="../../assets/dh-map/floor3-zcfjwwg.png" alt="">
      <img class="room floor3-lz4" src="../../assets/dh-map/floor3-lz4.png" alt="">
      <img class="room floor3-wfsskg" src="../../assets/dh-map/floor3-wfsskg.png" alt="">

    </div>
    <img class="bot-img b1" src="../../assets/dh-map/floor1-txt.png" alt=""  v-if="navCurr==1">
    <img class="bot-img b2" src="../../assets/dh-map/floor2-txt.png" alt=""  v-if="navCurr==2">
    <img class="bot-img b3" src="../../assets/dh-map/floor3-txt.png" alt=""  v-if="navCurr==3">
    <div class="r-box">
      <div class="item" :class="navCurr==1?'curr':''" @click="navCurrFun(1)">一楼</div>
      <div class="item" :class="navCurr==2?'curr':''" @click="navCurrFun(2)">二楼</div>
      <div class="item" :class="navCurr==3?'curr':''" @click="navCurrFun(3)">三楼</div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import {wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import Hammer from 'hammerjs'
  import { setTimeout } from 'timers'
  export default {
    data(){
      return{
        loadingHide:0,
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        navCurr:1,//1：一楼 2：二楼 3：三楼
        config: {},
        id: null,
        mc: null,
        timer: false,
        translateX: 0,
        translateY: 0,
        scale: 1.12,
        firstTouch: true,
        relateX: 0,
        relateY: 0,
        oldX: 0,
        oldY: 0,
        oldScale: 1.12,
        percentNum:0,//进度条百分比
      }
    },
    computed: {

    },
    activated() {
      if(this.loadingHide==1){
        this.$loading.hide();
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.picInit();
      });
    },
    created() {
      this.loadingFun();
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }
    },
    methods: {
      loadingFun(){
        var self = this;
        var loadTimer  = setInterval(function(){
          if (self.percentNum >= 100) {
            clearInterval(loadTimer);
          } else {
            self.percentNum++;
          }
        }, 50);
      },

      navCurrFun(id){
        this.navCurr = id;
        this.translateX = 0;
        this.translateY = 0;
        this.scale = 1.12;
        this.firstTouch = true;
        this.relateX = 0;
        this.relateY = 0;
        this.oldX = 0;
        this.oldY = 0;
        this.oldScale = 1.12;
        this.picInit();
      },
      picInit () {
        if(this.navCurr==1){
          this.id = document.getElementById('second1');
        }else if(this.navCurr==2){
          this.id = document.getElementById('second2');
        }else if(this.navCurr==3){
          this.id = document.getElementById('second3');
        }
        this.mc = new Hammer(this.id)
        this.relateX = 0;
        this.relateY = 0;

        this.mc.add(new Hammer.Pan({
          direction: Hammer.DIRECTION_ALL,
          threshold: 0,
          pointers: 0
        }))
        this.mc.add(new Hammer.Pinch({
          threshold: 0
        })).recognizeWith(this.mc.get('pan'))

        this.mc.on('hammer.input', this.isFinal)
        this.mc.on('panstart panmove', this.onPan)
        this.mc.on('pinchstart pinchmove', this.onPinch)

        this.setPosition()
      },
      isFinal (ev) {
        if (ev.isFinal) {
          this.oldX = this.translateX
          this.oldY = this.translateY
          this.oldScale = this.scale
        }
      },
      // 初始化图片位置及缩放
      setPosition () {
        this.selfPosition({
          translateX: this.relateX,
          translateY: this.relateY,
          scale: this.scale
        })
      },
      // 单点触发 - 拖拉
      onPan (ev) {
        // console.log(this.firstTouch)
        if (this.firstTouch) {
          this.oldX = this.relateX
          this.oldY = this.relateY
        }
        // console.log(this.oldX)
        // console.log(this.oldY)
        this.translateX = this.oldX + ev.deltaX
        this.translateY = this.oldY + ev.deltaY
        const position = {
          translateX: this.translateX,
          translateY: this.translateY,
          scale: this.scale
        }
        this.selfPosition(position)
        this.firstTouch = false
      },
      // 多点触发 - 缩放
      onPinch (ev) {
        this.scale = this.oldScale * ev.scale
        this.selfPosition({
          translateX: this.translateX,
          translateY: this.translateY,
          scale: this.scale
        })
        // this.selfPosition(this.position)
      },
      selfPosition (pos) {
        return this.picAnimate()(() => this.tempPos(pos))
      },
      tempPos (pos) {
        let style = [
          `translate3d(${pos.translateX}px, ${pos.translateY}px, 0)`,
          `scale(${pos.scale}, ${pos.scale})`
          // `scale(${pos.scale > 1.2 ? 1.2 : pos.scale}, ${pos.scale > 1.2 ? 1.2 : pos.scale})`
        ]
        style = style.join(' ')
        this.id.style.transform = style
      },
      picAnimate () {
        return window[Hammer.prefixed(window, 'requestAnimationFrame')] || function (callback) {
            setTimeout(callback, 1000 / 60)
          }
      },

      //跳转到景区页面
      goViewDetail(id){
        this.loadingHide = 1;
        this.$router.push({
          path: `/view-detail?${'shopid=' + id + '&siteid=' + this.siteid + '&sregion=' + this.sregion +'&isback=1&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey}`
        });
      },
    },
    components: {

    },

  }

</script>

<style scoped>
  .loading-box{position: absolute;left:0;top:0;z-index:9;width:100%;height:100%;background: #fff;
    -webkit-animation: loadOpt 6s linear;animation: loadOpt 6s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;
  }
  .loading-box .load-img{display:block;
    width: 1.23rem;
    /*width: 1.5rem;*/
    height: auto;margin: 30vh auto 0;
    /*-webkit-transform: rotateY(180deg);transform: rotateY(180deg);*/
    /*webkit-animation: loadImg 2s linear infinite;animation: loadImg 2s linear infinite;*/
  }
  .loading-box .bar{position:relative;width: 40vw;height: .24rem;margin:.2rem auto 0;border:1px solid #e3e3e3;border-radius: .12rem;overflow: hidden;}
  .loading-box .bar-curr{opacity:.8;position: absolute;left: 0;top: 0;width: 0;height: 100%;
    background: #a01e23;
    /*background: url(../../assets/dh-map/bar-bg.jpg) repeat center;*/
    border-radius: .12rem;overflow: hidden;-webkit-animation: loadBar 5s linear;animation: loadBar 5s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .loading-box .bar-txt{width: 100%;margin-top: .2rem;font-size: .24rem;color: #999;text-align: center;}
  .page{position: fixed;top:0;left:0;width:100%;height:100%;background: url(../../assets/dh-map/dh-map-bg.jpg) no-repeat center;background-size: cover;}


  @-webkit-keyframes loadOpt {
    0%{opacity: 1;}
    99%{opacity: .96;}
    100%{opacity: 0;z-index: -1;}
  }
  @keyframes loadOpt {
    0%{opacity: 1;}
    99%{opacity: .96;}
    100%{opacity: 0;z-index: -1;}
  }
  @-webkit-keyframes loadImg {
    0%{-webkit-transform: scale(1) rotateY(180deg);transform:  scale(1) rotateY(180deg);opacity: 1;}
    25%{-webkit-transform: scale(1.06) rotateY(180deg);transform:  scale(1.06) rotateY(180deg);opacity: .9;}
    50%{-webkit-transform: scale(1) rotateY(180deg);transform:  scale(1) rotateY(180deg);opacity: 1;}
    75%{-webkit-transform: scale(1.06) rotateY(180deg);transform:  scale(1.06) rotateY(180deg);opacity: .9;}
    100%{-webkit-transform: scale(1) rotateY(180deg);transform:  scale(1) rotateY(180deg);opacity: 1;}
  }
  @keyframes loadImg {
    0%{-webkit-transform: scale(1);transform: scale(1);opacity: 1;}
    25%{-webkit-transform: scale(1.02);transform: scale(1.02);opacity: .9;}
    50%{-webkit-transform: scale(1);transform: scale(1);opacity: 1;}
    75%{-webkit-transform: scale(1.02);transform: scale(1.02);opacity: .9;}
    100%{-webkit-transform: scale(1);transform: scale(1);opacity: 1;}
  }
  @-webkit-keyframes loadBar {from{width: 0;}to{width: 100%;}}
  @keyframes loadBar {from{width: 0;}to{width: 100%;}}

  .second{position: absolute;left: 0;top:20vw;width:100%;height: 119.996vw;}
  .top-img{position: absolute;left: 0;top: 0;width:100%;height: 100%;object-fit: contain;}
  .bot-img{position: absolute;left: 11.27vw;bottom:19.7%;width:77.46vw;height: 23.7vw;object-fit: contain;}
  /*.bot-img.b1{background: url(../../assets/dh-map/floor1-txt.png) no-repeat center;background-size: 100% 100%;}*/
  /*.bot-img.b2{background: url(../../assets/dh-map/floor2-txt.png) no-repeat center;background-size: 100% 100%;}*/
  /*.bot-img.b3{background: url(../../assets/dh-map/floor3-txt.png) no-repeat center;background-size: 100% 100%;}*/
  .r-box{position: absolute;top:30%;right: 2%;width: 1rem;}
  .r-box .item{width:100%;height:.52rem;line-height:.5rem;margin-top:.2rem;text-align: center;font-size: .28rem;font-weight: bold;color: #333;background: url(../../assets/dh-map/nav-bg.png) no-repeat center;background-size: 100% 100%;}
  .r-box .item:first-child{margin-top: 0;}
  .r-box .item.curr{background: url(../../assets/dh-map/nav-curr-bg.png) no-repeat center;background-size: 100% 100%;}
  .room{position: absolute;z-index: 1;}
  .room.link{-webkit-animation: loadImg 1.6s linear infinite;animation: loadImg 1.6s linear infinite;}
  .floor1-lz1{width:15.56%;left:12.6%;top:26%;}
  .floor1-lz2{width:15.56%;left:12.6%;top:49%;}
  .floor1-lz3{width:15.56%;left:34.2%;top:51%;}
  .floor1-ht1{width:18.6%;left:53.2%;top:25.1%;}
  .floor1-ht2{width:18.6%;left:53.2%;top:45.5%;}

  .floor2-cbbgq{width: 14.29%;left: 32.6%;top: 11%;}
  .floor2-cbxy{width: 6.48%;left: 85.1%;top: 17%;}
  .floor2-zdqysg{width: 18.43%;left: 11.2%;top: 29.2%;}
  .floor2-ygsc{width: 15.56%;left: 53.6%;top: 29.2%;}
  .floor2-xsbgt{width: 11.76%;left: 71.8%;top: 26%;}
  .floor2-shg{width: 15.56%;left: 11.2%;top: 48.8%;}
  .floor2-gdsc{width: 15.56%;left: 54.8%;top: 48.8%;}
  .floor2-bgq{width: 8.02%;left: 48.3%;top: 62%;}

  .floor3-xxjjy{width: 7.3%;left: 18.3%;top: 18.4%;}
  .floor3-zyzzj{width: 7.94%;left: 70.9%;top: 17.9%;}
  .floor3-scmzwwg{width: 20.64%;left: 18.3%;top: 26.8%;}
  .floor3-lz5{width: 15.56%;left: 60.2%;top: 26.8%;}
  .floor3-gymsg{width: 15.56%;left: 18.9%;top: 42.8%;}
  .floor3-zcfjwwg{width: 19.13%;left: 59.8%;top: 42.8%;}
  .floor3-lz4{width: 15.56%;left: 20.4%;top: 57.5%;}
  .floor3-wfsskg{width: 18.6%;left: 59.4%;top: 57.9%;}

  @-webkit-keyframes linkOpt {
    0%{opacity: 1;}
    25%{opacity: .68;}
    50%{opacity: 1;}
    75%{opacity: .68;}
    100%{opacity: 1;}
  }
  @keyframes linkOpt {
    0%{opacity: 1;}
    25%{opacity: .68;}
    50%{opacity: 1;}
    75%{opacity: .68;}
    100%{opacity: 1;}
  }
</style>



// WEBPACK FOOTER //
// src/page/h5/dh-map.vue